// Copyright  Sorama B.V.

import { TimelineEntryType } from "datatypes/SoramaWebApi";

export class TimeLineEventTypeToStringValueConverter {
    public toView(value: TimelineEntryType): string {
        switch (value) {
            case TimelineEntryType.FarfieldAnalysis:
                return "Far field Analysis";
            case TimelineEntryType.NearfieldAnalysis:
                return "Near Field Analysis";
            case TimelineEntryType.SpectrogramAnalysis:
                return "Spectrogram Analysis";
            case TimelineEntryType.SpectrumAnalysis:
                return "Spectrum Analysis";
            case TimelineEntryType.TimeAnalysis:
                return "Time Analysis";
            case TimelineEntryType.Measurement:
                return "Measurement";
        }
    }
}
